import { sendMail } from '../util/api';
import { storableError } from '../util/errors';

// ================ Action types ================ //

export const CONTACT_US_REQUEST = 'app/Contact/CONTACT_US_REQUEST';
export const CONTACT_US_SUCCESS = 'app/Contact/CONTACT_US_SUCCESS';
export const CONTACT_US_ERROR = 'app/Contact/CONTACT_US_ERROR';


// ================ Reducer ================ //

const initialState = {
  // contact
  contactUsError: null,
  contactUsInProgress: false,
  contactUsSuccess: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case CONTACT_US_REQUEST:
      return {
        ...state,
        contactUsInProgress: true,
        contactUsSuccess: null,
        contactUsError: null,
      };
    case CONTACT_US_SUCCESS:
      return {
        ...state,
        contactUsInProgress: false,
        contactUsSuccess: payload,
      };
    case CONTACT_US_ERROR:
      return {
        ...state,
        contactUsInProgress: false,
        contactUsSuccess: false,
        contactUsError: payload
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const contactUsRequest = () => ({ type: CONTACT_US_REQUEST });
export const contactUsSuccess = (res) => ({ type: CONTACT_US_SUCCESS, payload: res });
export const contactUsError = error => ({ type: CONTACT_US_ERROR, payload: error, error: true });


// ================ Thunks ================ //

export const contactUs = (params) => (dispatch) => {
  dispatch(contactUsRequest());


  return sendMail(params)
    .then(response => {
      dispatch(contactUsSuccess(true));
    })
    .then(response => {
      setTimeout(() => {
        dispatch(contactUsSuccess(false));
      }, 5000)
    })
    .catch(e => {
      dispatch(contactUsError(storableError(e)));
    });
};
